/**
 * Eticheta de langa Overview - "Live", "40s", "12m", "3h", "5d" - din
 * device_workspace.js (seenAgeLabel / tickDeviceSeen). Pragurile sunt cele
 * din OdLastActivity (od_ux.js): sub 5 secunde vorbeste chiar acum, peste 8
 * ore a tacut destul cat sa te intrebi de ce.
 */

export const SEEN_LIVE_UNDER = 5
export const SEEN_STALE_OVER = 8 * 3600

export function seenAgeLabel(age: number): string {
  age = Math.max(0, Math.trunc(Number.isFinite(age) ? age : 0))

  if (age < SEEN_LIVE_UNDER) return 'Live'
  if (age < 60) return `${age}s`
  if (age < 3600) return `${Math.round(age / 60)}m`
  if (age < 86400) return `${Math.round(age / 3600)}h`
  return `${Math.round(age / 86400)}d`
}

/** Varsta in secunde a unui timestamp "YYYY-MM-DD HH:mm:ss" (ora serverului), null daca nu se poate citi. */
export function seenAge(raw: string, now = Date.now()): number | null {
  if (!raw) return null
  const stamp = Date.parse(raw.replace(' ', 'T'))
  if (!stamp) return null
  return Math.max(0, Math.round((now - stamp) / 1000))
}
